import { createRouter, createWebHistory } from 'vue-router'
import axios from 'axios'

import Login from '../views/Login.vue'
import Signup from '@/views/Signup.vue'
import Dashboard from '@/views/Dashboard.vue'
import Servers from '@/views/Servers.vue'
import Billing from '@/views/Billing.vue'
import Settings from '@/views/Settings.vue'
import Support from '@/views/Support.vue'
import ViewTicket from '@/views/ViewTicket.vue'
import Affiliates from '@/views/Affiliates.vue'
import Manage from '@/views/Manage.vue'
import Order from '@/views/Order.vue'
import Storage from '@/views/Storage.vue'
import Logout from '@/views/Logout.vue'
import Invoice from '@/views/Invoice.vue'
import Firewall from '@/views/Firewall.vue'
import Network from '@/views/Network.vue'
import LoadBalancers from '@/views/LoadBalancers.vue'
import Kubernetes from '@/views/Kubernetes.vue'
import Cdn from '@/views/Cdn.vue'
import Databases from '@/views/Databases.vue'
import PrivateNetworking from '@/views/PrivateNetworking.vue'
import ForgotPassword from '@/views/ForgotPassword.vue'
import ResetPassword from '@/views/ResetPassword.vue'
import VerifyEmail from '@/views/VerifyEmail.vue'

// ADMIN PAGES
import Users from '@/views/Admin/Users.vue'
import Tickets from '@/views/Admin/Tickets.vue'
import AdminOrders from '@/views/Admin/AdminOrders.vue'
import AdminDashboard from '@/views/Admin/AdminDashboard.vue'
import AdminAffiliate from '@/views/Admin/AdminAffiliate.vue'
import OrderDetails from '@/views/Admin/OrderDetails.vue'
import User from '@/views/Admin/User.vue'
import AdminTicketReply from '@/views/Admin/AdminTicketReply.vue'
import IncomeReport from '@/views/Admin/IncomeReport.vue'
import AddNode from '@/views/Admin/AddNode.vue'
import Nodes from '@/views/Admin/Nodes.vue'
import EditNode from '@/views/Admin/EditNode.vue'
import PendingNetworks from '@/views/Admin/PendingNetworks.vue'
import AdminServers from '@/views/Admin/Servers.vue'
import Roles from '@/views/Admin/Roles.vue'
import Staff from '@/views/Admin/Staff.vue'

const routes = [
  { path: '/', redirect: '/login' },
  {
    path: '/login',
    name: 'login',
    component: Login
  },  
  {
    path: '/forgot-password',
    name: 'forgotpassword',
    component: ForgotPassword
  },  
  {
    path: '/reset-password/:token',
    name: 'resetpassword',
    component: ResetPassword,
    props: true
  },  
  {
    path: '/signup',
    name: 'signup',
    component: Signup
  }, 
  {
    path: '/verify-email',
    name: 'verifyemail',
    component: VerifyEmail
  }, 
  {
    path: '/dashboard',
    name: 'dashboard',
    component: Dashboard,
    meta: { requiresAuth: true },
  }, 
  {
    path: '/servers',
    name: 'servers',
    component: Servers,
    meta: { requiresAuth: true },
  },
  {
    path: '/billing',
    name: 'billing',
    component: Billing,
    meta: { requiresAuth: true },
  },
  {
    path: '/settings',
    name: 'settings',
    component: Settings,
    meta: { requiresAuth: true },
  },
  {
    path: '/support',
    name: 'support',
    component: Support,
    meta: { requiresAuth: true },
  },
  {
    path: '/view_ticket/:id',
    name: 'viewticket',
    component: ViewTicket,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/affiliates',
    name: 'affiliates',
    component: Affiliates,
    meta: { requiresAuth: true },
  },
  {
    path: '/manage/:serverId',
    name: 'manage',
    component: Manage,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/order',
    name: 'order',
    component: Order,
    meta: { requiresAuth: true },
  },
  {
    path: '/storage',
    name: 'storage',
    component: Storage,
    meta: { requiresAuth: true },
  },
  {
    path: '/logout',
    name: 'logout',
    component: Logout
  },
  {
    path: '/invoice/:id',
    name: 'invoice',
    component: Invoice,
    meta: { requiresAuth: true },
    props: true,
  },
  {
    path: '/user/:id',
    name: 'userdetails',
    component: User,
    meta: { requiresAuth: true, permission: 'view_users' },
    props: true,
  },
  {
    path: '/firewall/:id',
    name: 'firewall',
    component: Firewall,
    meta: { requiresAuth: true},
    props: true,
  },
  {
    path: '/orders/:id',
    name: 'vieworder',
    component: OrderDetails,
    meta: { requiresAuth: true, permission: 'view_orders' },
    props: true,
  },
  {
    path: '/load-balancers',
    name: 'loadbalancers',
    meta: { requiresAuth: true},
    component: LoadBalancers
  },
  {
    path: '/network',
    name: 'network',
    meta: { requiresAuth: true},
    component: Network
  },
  {
    path: '/kubernetes',
    name: 'Kubernetes',
    meta: { requiresAuth: true},
    component: Kubernetes
  },
  {
    path: '/cdn',
    name: 'cdn',
    meta: { requiresAuth: true},
    component: Cdn
  },
  {
    path: '/databases',
    name: 'db',
    meta: { requiresAuth: true},
    component: Databases
  },
  {
    path: '/private-networks',
    name: 'privatenetwork',
    meta: { requiresAuth: true},
    component: PrivateNetworking
  },
  {
    path: '/admin/affiliates',
    name: 'adminaffiliates',
    component: AdminAffiliate,
    meta: { requiresAuth: true, permission: 'view_affiliates' },
  },
  {
    path: '/admin/dashboard',
    name: 'admindashboard',
    component: AdminDashboard,
    meta: { requiresAuth: true, permission: 'view_dashboard' },
  },
  {
    path: '/admin/orders',
    name: 'adminorders',
    component: AdminOrders,
    meta: { requiresAuth: true, permission: 'view_orders' },
  },
  {
    path: '/admin/users',
    name: 'adminusers',
    component: Users,
    meta: { requiresAuth: true, permission: 'view_users' },
  },
  {
    path: '/admin/tickets',
    name: 'admintickets',
    component: Tickets,
    meta: { requiresAuth: true, permission: 'view_tickets' },
  },
  {
    path: '/admin/view_ticket/:id',
    name: 'adminticketview',
    component: AdminTicketReply,
    meta: { requiresAuth: true, permission: 'view_tickets' },
    props: true,
  },
  {
    path: '/admin/income-report/',
    name: 'incomereport',
    component: IncomeReport,
    meta: { requiresAuth: true, permission: 'view_income_reports' },
  },
  {
    path: '/admin/add-node/',
    name: 'addnode',
    component: AddNode,
    meta: { requiresAuth: true, permission: 'view_nodes' },
  },
  {
    path: '/admin/nodes/',
    name: 'nodes',
    component: Nodes,
    meta: { requiresAuth: true, permission: 'view_nodes' },
  },
  {
    path: '/admin/edit/:id',
    name: 'editnode',
    component: EditNode,
    meta: { requiresAuth: true, permission: 'view_nodes' },
    props: true,
  },
  {
    path: '/admin/networks/',
    name: 'approvenetwork',
    component: PendingNetworks,
    meta: { requiresAuth: true, permission: 'view_networks' },
    props: true,
  },
  {
    path: '/admin/servers/',
    name: 'adminservers',
    component: AdminServers,
    meta: { requiresAuth: true, permission: 'view_servers' },
    props: true,
  },
  {
    path: '/admin/roles/',
    name: 'adminroles',
    component: Roles,
    meta: { requiresAuth: true, permission: 'view_roles' },
    props: true,
  },
  {
    path: '/admin/staff/',
    name: 'staffpage',
    component: Staff,
    meta: { requiresAuth: true, permission: 'view_roles' },
    props: true,
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes,
});

// Navigation Guard
router.beforeEach(async (to, from, next) => {
  if (to.meta.requiresAuth) {
    try {
      const response = await axios.get("https://api.syniac.com:3000/api/auth/session", { withCredentials: true });
      
      if (!response.data.loggedIn) return next('/login');

      const user = response.data.user;

      // If the route requires a specific permission
      if (to.meta.permission) {
        // Admin shortcut
        if (user.role !== 'admin' && !user.permissions.includes(to.meta.permission)) {
          return next('/dashboard'); // redirect if lacking permission
        }
      }

      return next(); 
    } catch {
      return next('/login');
    }
  }
  next();
});


export default router
